import { changeFilteredInfo } from "@/utils/data/tableCol/tableUtils";

export const TeamContractAudit = (filteredInfos) => {
    let filteredInfo = changeFilteredInfo(filteredInfos)
    return [
        {
            title: '操作',
            key: 'operation',
            scopedSlots: { customRender: 'operation' },
            width: 150
        },
        {
            title: '合同编号',
            dataIndex: 'data.contractNumber',
            key: 'contractNumber',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
                customRender: 'contractNumber'
            },
            filteredValue: filteredInfo.contractNumber || [],
        },
        {
            title: '审核状态',
            dataIndex: 'status',
            key: 'status',
            scopedSlots: {
                filterDropdown: 'filterStatus',
                filterIcon: 'filterIcon',
                filtered: true,
                customRender: 'status'
            },
            filteredValue: filteredInfo.status || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '审批原因',
            dataIndex: 'rejectionReason',
            key: 'rejectionReason',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.rejectionReason || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '合同名称',
            dataIndex: 'data.contractName',
            key: 'contractName',
            scopedSlots: {
                customRender: 'contractName'
            }
        },
        {
            title: '合同类型',
            dataIndex: 'data.projectType',
            key: 'projectType'
        },
        {
            title: '合同分类',
            dataIndex: 'data.contractType',
            key: 'contractType',
            scopedSlots: {
                filterDropdown: 'filterContractType',
                filterIcon: 'filterIcon',
                filtered: true,
                customRender: 'contractType'
            },
            filteredValue: filteredInfo.contractType || []
        },
        {
            title: '合同金额',
            dataIndex: 'data.contractAmount',
            key: 'contractAmount'
        },
        {
            title: '合同拟定时间',
            dataIndex: 'data.contractDraftingDate',
            key: 'contractDraftingDate'
        },
        {
            title: '销售',
            dataIndex: 'data.sales.name',
            key: 'salesName',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.salesName || [],
        },
        {
            title: '委托方（甲方）',
            dataIndex: 'data.customerContacts.contactName',
            key: 'contactName',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
                customRender: 'contact'
            },
            filteredValue: filteredInfo.contactName || [],
        },
        {
            title: '受托方（乙方）',
            dataIndex: 'data.baseCompany.companyName',
            key: 'baseCompanyName'
        },
        {
            title: '乙方项目联系人',
            dataIndex: 'data.trusteeContacts.name',
            key: 'trusteeContactsName',
        },
        {
            title: '创建人',
            dataIndex: 'sponsor',
            key: 'sponsor',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.sponsor || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '创建时间',
            dataIndex: 'createTime',
            key: 'createTime'
        },
        {
            title: '审批人员',
            dataIndex: 'operator',
            key: 'operator',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.operator || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '审核时间',
            dataIndex: 'auditTime',
            key: 'auditTime'
        },
        {
            title: '备注',
            dataIndex: 'data.remark',
            key: 'remark'
        },
    ]
}
